export default __webpack_public_path__ + "static/media/regulatory--maximum-speed-limit-led-70--g1.aa082679.png";